import { useErrorStore } from 'app/context/errorStore';
import { getEntityById, getCheckoutById } from '../http/checkoutService';
import { useCheckoutFrameStore } from 'app/context/checkoutStore';

export const useCheckoutGet = () => {
  const { setError, setIsLoading } = useErrorStore();
  const { setCheckoutRequest, setEntity } = useCheckoutFrameStore();

  const doGet = async (checkoutId: string) => {
    try {
      setIsLoading(true);
      const checkoutRequest = await getCheckoutById(checkoutId);
      const entity = await getEntityById(checkoutRequest.entityId);
      setCheckoutRequest(checkoutRequest);
      setEntity(entity);
    } catch (e: any) {
      setError(e);
    }
  };

  return {
    doGet,
  };
};
